export { default } from "./PlayerDetailContainer";
